import { render, staticRenderFns } from "./tableRelatorioGecom.vue?vue&type=template&id=3115559d&scoped=true&"
import script from "./tableRelatorioGecom.vue?vue&type=script&lang=js&"
export * from "./tableRelatorioGecom.vue?vue&type=script&lang=js&"
import style0 from "./tableRelatorioGecom.vue?vue&type=style&index=0&id=3115559d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3115559d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VDataTable,VSkeletonLoader})
